import { useQuery } from "@tanstack/react-query"
import { queryKeys } from "../queryKeys"
import { cdFetch } from "../api"
import { HomeData, HomeFilterRes } from "../../services/interfaces/IHomePage";

const normalize = (input?: Array<string> | null) => {
    if (!Array.isArray(input) || input.length === 0) return null;
    return input.slice().sort();
}

const getQueryParams = (commodity: string | null, district?: string[] | null) => {
    let qParams = '';
    if (commodity != null && commodity.length > 0) {
        qParams += `commodity=${JSON.stringify(commodity)}&`
    }
    if (district && district.length > 0) {
        qParams += `district=${JSON.stringify(district)}&`
    }

    if (qParams.length > 0) {
        qParams = '?' + qParams.slice(0, -1);
    }

    return qParams;
}

export const useHomeFilters = (commodity: string | null, district?: string[] | null) => {
    const { data: res, isLoading } = useQuery({
        queryKey: [queryKeys.home, 'filters', commodity, normalize(district)],
        queryFn: () => getFilters(commodity, district),
    })
    const fetchFilters: HomeFilterRes = { ...res?.data };
    return { fetchFilters, isLoading };
}

const getFilters = (commodity: string | null, district?: string[] | null) => {
    const queryParams = getQueryParams(commodity, district);
    const res = cdFetch(`/getAllFiltersLandingPage${queryParams}`);
    return res;
}

export const useUserDetails = (userEmail: string | null) => {
    if (userEmail != null) {

        const { data, isLoading } = useQuery({
            queryKey: [queryKeys.userDetails, userEmail],
            queryFn: () => getUserDetails(userEmail),
            enabled: userEmail ? true : false
        })
        return { userDetails: { ...data?.data }, isLoading };
    } else {
        return {};
    }
}

const getUserDetails = (email: string) => {
    const res = cdFetch(`/getUserData?user_email=${JSON.stringify(email)}`);
    return res;
}

export const useHomeData = (commodity: string | null, district: string[] | null) => {
    const { data: res, isLoading } = useQuery({
        queryKey: [queryKeys.home, 'kpi', commodity, normalize(district)],
        queryFn: () => getHomeData(commodity, district),
        staleTime: 1000
    })
    let data: HomeData = res?.data;
    return { data, isLoading };
}

const getHomeData = (commodity: string | null, district?: string[] | null) => {
    const queryParams = getQueryParams(commodity, district);
    const res = cdFetch(`/getLandingPageData${queryParams}`);
    return res;
}